export default __webpack_public_path__ + "static/media/verification.cfca10fa.svg";